/**
 * @description 轮呼hooks
 */

import {
  getNextContactInfo,
  pcEvokeMobileStartRoundCall,
  roundCallRecall,
  roundCallRelateCustomer,
  roundCallshutdown,
  startAndGetContactInfo
} from '@/apis/callCenter/turnCall'
import {
  CallingCode,
  callDirection,
  callType,
  dialingScenes,
  callCenterStatusEnum
} from '@/enums/callCenter'
import { useCallCenter } from '@/stores/modules/callCenter'
import type { CallUserInfoVO } from '@/types/callCenter/callCenter'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { phoneReg } from '@/utils/regExp'
import { ref, unref } from 'vue'
import { useDaco } from './daco'
import { useJsSIP } from './jssip'
import MyGlobalEvent from '@/utils/bus/baseBus'
import { useAccountStore } from '@/stores/modules/account'
import { pcEvokeCellPhoneDial, sipQuickDialRelateCdr } from '@/apis/callCenter/callCenter'

const currentTaskInfo = ref<Recordable>()
const loading = ref()
const useDacoHooks = ref()
const useJsSIPHooks = ref()
// const { userInfo } = useAccountStore()

export function useTurnCall() {
  const { userInfo } = useAccountStore()
  // 开始轮呼任务(pc)
  const callCenter = useCallCenter()

  async function startRoundCallProcessPc(taskInfo?: Recordable) {
    const taskInfoValue = taskInfo || currentTaskInfo.value
    useDacoHooks.value = useDaco()
    useJsSIPHooks.value = useJsSIP()
    if (!isNullOrUndefOrEmpty(taskInfo)) {
      currentTaskInfo.value = unref(taskInfo)
    }
    // 设置呼出
    callCenter.setCallDirection(callDirection.out)
    loading.value = ElLoading.service({
      lock: true
    })
    let params: Recordable = {}
    if (callCenter.staffDefaultCallType === callType.daco) {
      params = {
        callType: callCenter.staffDefaultCallType,
        iccid: callCenter.iccid,
        caller: callCenter.callerPhone
      }
    } else {
      params = {
        callType: callCenter.staffDefaultCallType,
        lineId: callCenter?.lineInfo?.lineId,
        serverType: callCenter?.lineInfo?.serverType,
        feeFlag: callCenter?.lineInfo?.feeFlag,
        allUsedFlag: callCenter?.lineInfo?.allUsedFlag
      }
    }
    try {
      // 获取拨打联系人信息
      const res = await startAndGetContactInfo({
        ...params,
        taskId: taskInfoValue?.taskId,
        version: 160
      })
      if (!phoneReg.test(res.plaintextPhoneNum)) {
        ElMessage.error('呼叫失败，该手机号格式错误，请拨打正确的手机号')
        loading.value.close()
        shutdown()
        return false
      }
      MyGlobalEvent.$emit('roundCallTableRefresh')
      MyGlobalEvent.$emit('roundCallDetailRefresh')
      callCenter.setdialingScenes(dialingScenes.turnCall)
      // 是否设置话机脱敏
      if (callCenter.staffDefaultCallType === callType.daco) {
        useDacoHooks.value.setHidNumber(res?.deviceDesensitization || false)
      }
      tidyUpUserInfo(res)
    } catch (error) {
      console.log(error, 'errorerror')
      console.log('拨打场景', callCenter.dialingScenes)
      callCenter.setdialingScenes(dialingScenes.turnCall)
      loading.value.close()
      errorCode(error)
    }
  }

  // 错误
  function errorCode(error: any) {
    console.log(error)
    // store.dispatch('setIsRefreshTable', true)
    if (error.code?.toString() === '103') {
      shutdown()
      // 需要切卡
      useDacoHooks.value.changeSim()
    } else if (error.code?.toString() === '-150') {
      // 坐席过期 终止呼叫
      shutdown()
    } else if (error.code?.toString() === '122') {
      // 黑名单，继续呼叫
      callCenter.setCallingCode(CallingCode.WAIT)
      showCountDown()
    } else if (error.code?.toString() === '108') {
      // 发送短信，终止呼叫
      shutdown()
      useDacoHooks.value.bindPhoneNumber()
    } else {
      shutdown()
    }
  }

  function tidyUpUserInfo(data: Recordable) {
    const userInfo: CallUserInfoVO = {
      title: {
        ...data,
        roundCustomerId: data.id,
        customerId: data.id,
        phoneCheckResult: data.phoneCheckResult || '',
        desensitizePhoneNum: data.phone,
        plaintextPhone: data.plaintextPhoneNum,
        linkName: '',
        enterpriseName: data.name,
        realName: data.name,
        unknow: false
      },
      userList: [],
      gcId: data.gcId || ''
    }
    if (
      isNullOrUndefOrEmpty(data.relateShopOrderId) ||
      data.relateShopOrderId === 0 ||
      isNullOrUndefOrEmpty(data.contactInfoVO)
    ) {
      // 陌生客户
      userInfo!.title!.unknow = true
      userInfo!.title!.dataFrom = 1
      userInfo!.title!.linkName = ''
    } else {
      // 关联客户 存储关联客户ID
      userInfo!.title!.unknow = false
      userInfo!.title!.linkName = data?.name
      userInfo!.title!.enterpriseName =
        data.contactInfoVO?.enterpriseName || data.contactInfoVO?.realName
      userInfo!.title!.realName = data.contactInfoVO?.realName
      ;(userInfo!.title!.dataFrom = data.contactInfoVO?.dataFrom),
        (userInfo!.title!.objectId = data.contactInfoVO?.objectId)
      userInfo!.title!.customerId = data.relateShopOrderId
      userInfo!.title!.belongOpenSeaId = data.contactInfoVO?.belongOpenSeaId
      userInfo!.title!.followUserId = data.contactInfoVO?.followUserId
    }
    console.log(userInfo, 'userInfo')
    callCenter.setCallUserInfo(userInfo)
    loading.value.close()
    callCenter.dialingScenes === dialingScenes.turnCall
      ? pcRoundCall(data.plaintextPhoneNum)
      : mobileRoundCall(userInfo)
  }

  // PC 轮呼
  function pcRoundCall(phone: string) {
    if (callCenter.staffDefaultCallType === callType.daco) {
      useDacoHooks.value.getCallNumber()
    } else {
      setRoundCallRules(phone).then(res => {
        useJsSIPHooks.value.jssipCall(res)
      })
    }
  }

  /**
   * PC唤起APP轮呼
   */
  function evokeMobileStartRoundCall(taskInfo?: Recordable) {
    const taskInfoValue = taskInfo || currentTaskInfo.value
    useDacoHooks.value = useDaco()
    useJsSIPHooks.value = useJsSIP()
    if (!isNullOrUndefOrEmpty(taskInfo)) {
      currentTaskInfo.value = unref(taskInfo)
    }
    // 设置呼出
    callCenter.setCallDirection(callDirection.out)
    loading.value = ElLoading.service({
      lock: true
    })

    pcEvokeMobileStartRoundCall({
      taskId: taskInfoValue?.taskId
    })
      .then(res => {
        // 手机号码格式校验
        if (!phoneReg.test(res.plaintextPhoneNum)) {
          ElMessage.error('呼叫失败，该手机号格式错误，请拨打正确的手机号')
          loading.value.close()
          shutdown()
          return false
        }
        MyGlobalEvent.$emit('roundCallTableRefresh')
        MyGlobalEvent.$emit('roundCallDetailRefresh')

        const userInfo: CallUserInfoVO = {
          title: {
            ...res,
            roundCustomerId: res.id,
            phoneCheckResult: res.phoneCheckResult || '',
            desensitizePhoneNum: res.phone,
            plaintextPhone: res.plaintextPhoneNum,
            linkName: '',
            enterpriseName: res.name,
            realName: res.name,
            unknow: false
          },
          userList: [],
          gcId: res.gcId || ''
        }
        if (
          isNullOrUndefOrEmpty(res.relateShopOrderId) ||
          res.relateShopOrderId === 0 ||
          isNullOrUndefOrEmpty(res.contactInfoVO)
        ) {
          // 陌生客户
          userInfo!.title!.unknow = true
          userInfo!.title!.dataFrom = 1
          userInfo!.title!.linkName = ''
        } else {
          // 关联客户 存储关联客户ID
          userInfo!.title!.unknow = false
          userInfo!.title!.linkName = res.name
          userInfo!.title!.enterpriseName =
            res.contactInfoVO?.enterpriseName || res.contactInfoVO?.realName
          userInfo!.title!.realName = res.contactInfoVO?.realName
          userInfo!.title!.objectId = res.contactInfoVO?.objectId
          userInfo!.title!.customerId = res.relateShopOrderId
          userInfo!.title!.dataFrom = res.contactInfoVO?.dataFrom
        }
        console.log(userInfo)
        mobileRoundCall(userInfo)
        loading.value.close()
      })
      .catch(() => {
        shutdown()
        loading.value.close()
      })
  }
  // APP 轮呼
  function mobileRoundCall(userInfo: CallUserInfoVO) {
    console.log('APP 轮呼', userInfo)
    callCenter.setdialingScenes(dialingScenes.turnCallApp)
    callCenter.setCallUserInfo(userInfo)
    if (userInfo?.title?.unknow) {
      evokeAPP(userInfo)
    } else {
      if (userInfo.title?.dataFrom === 1) {
        roundCallRelateCustomer({
          relateShopOrderId: userInfo?.title?.customerId,
          relateLinkId: userInfo?.title?.objectId,
          id: userInfo?.title?.roundCustomerId
        })
      }
      evokeAPP(userInfo)
    }
  }

  // 唤起APP
  function evokeAPP(userInfo: CallUserInfoVO) {
    pcEvokeCellPhoneDial({
      bizType: userInfo?.title?.bizType,
      objectId: userInfo?.title?.roundCustomerId,
      scene: 1
    }).then(() => {
      ElMessage.warning('正尝试唤起手机端呼叫，请保持手机亮屏并打开APP软件')
    })
  }
  // 获取下一个联系人信息用作倒计时展示
  function showNextInfo() {
    loading.value = ElLoading.service({
      lock: true
    })
    getNextContactInfo({
      taskId: currentTaskInfo.value?.taskId
    })
      .then(res => {
        console.log(res, '获取下一个联系人信息用作倒计时展示')
        if (!isNullOrUndefOrEmpty(res)) {
          const userInfo = {
            title: {
              plaintextPhone: res.phone,
              unknow: true,
              phoneCheckResult: res.phoneCheckResult || '',
              roundCustomerId: res.id,
              desensitizePhoneNum: res.desensitizePhone,
              linkName: '',
              enterpriseName: res.name,
              realName: res.name
            },
            userList: []
          }
          callCenter.setCallUserInfo(userInfo)
          callCenter.setShowCallScreen(true)
        } else {
          callCenter.dialingScenes === dialingScenes.turnCall
            ? startRoundCallProcessPc()
            : evokeMobileStartRoundCall()
        }
        loading.value.close()
      })
      .catch(() => {
        shutdown()
        loading.value.close()
      })
  }

  // 终止轮呼
  async function shutdown(taskInfo?: Recordable) {
    console.log(taskInfo, '终止轮呼')
    console.log(currentTaskInfo.value, '终止轮呼')
    const data = taskInfo || currentTaskInfo.value
    // store.dispatch('setIsRefreshTable', true)
    try {
      await roundCallshutdown({
        taskId: data?.taskId
      })
      stop()
      MyGlobalEvent.$emit('roundCallTableRefresh')
      MyGlobalEvent.$emit('roundCallDetailRefresh')
    } catch (error) {
      stop()
    }
  }

  function stop() {
    // store.dispatch('setIsCalling', false)
    callCenter.setCallingCode(CallingCode.CBEGIN)
    callCenter.setdialingScenes(dialingScenes.singleCall)
    callCenter.setShowCallScreen(false)
    // store.commit('SET_VIEW_SEAT_STATUS', store.getters.viewSeatStatus)
    // store.dispatch('setQuickCall', false)
    // store.dispatch('setIsChooseCallWay', false)
    // clearInterval(store.state.callCenter.callInterval)
    // store.dispatch('setRoundCallSwitch', 0)
    // store.dispatch('', false)
    // if (!store.state.callCenter.roundCallIn) {
    //   if ((!store.state.callCenter.showCustom && !store.state.callCenter.showEnterPrise) && !store.state.callCenter.relateVisible) {
    //     store.commit('RE_SET_CALL_CONFIG')
    //   }
    // }
  }
  // 判断是否需要倒计时
  function showCountDown() {
    console.log('倒计时来了。')
    if (callCenter.notCountDownFlag === 1) {
      // 不需要倒计时
      // 直接拨打
      callCenter.setCallUserInfo({})
      callCenter.setCallingCode(CallingCode.CORG)
      callCenter.dialingScenes === dialingScenes.turnCall
        ? startRoundCallProcessPc()
        : evokeMobileStartRoundCall()
    } else {
      // 显示倒计时
      showNextInfo()
      callCenter.setCallingCode(CallingCode.WAIT)
    }
  }

  // 再次呼叫
  function reCall() {
    loading.value = ElLoading.service({
      lock: true
    })
    callCenter.setShowCallScreen(false)
    callCenter.setCallingCode(CallingCode.CEND)
    callCenter.setCallCenterStatus(callCenterStatusEnum.READY)
    MyGlobalEvent.$emit('roundCallDetailRefresh') // 刷新任务列表
    roundCallRecall({
      taskId: currentTaskInfo.value?.taskId
    })
      .then(res => {
        tidyUpUserInfo(res)
        loading.value.close()
      })
      .catch(error => {
        console.log(error)
        loading.value.close()
        errorCode(error)
      })
  }

  async function setRoundCallRules(phone: string) {
    // 轮呼普通客户 前缀HD, 轮呼企业客户前缀GD
    let customId: string | number = 0
    let userId = userInfo.id
    if (!userId) {
      // 线上出现了200ubndefined的情况，补救这种情况
      await useAccountStore?.()?.getUser?.()
      userId = useAccountStore()?.userInfo?.id
    }
    customId = 'HD' + callCenter?.callUserInfo?.title?.roundCustomerId
    //  轮呼普通客户 前缀HD, 轮呼企业客户前缀GD
    const rules = `200${userId}#${customId}#${callCenter?.callUserInfo?.gcId}#${phone}`
    const jssipCallId = `${callCenter.lineInfo?.lineId}_${phone}_${
      callCenter.lineInfo?.prefix || ''
    }_${callCenter.lineInfo?.suffix || ''}_${rules}`

    console.log(jssipCallId, 'sip轮呼拨打电话的规则id')
    callCenter.setJssipCallId(rules)
    return jssipCallId
  }

  /**
   * 轮呼关联
   */
  function roundCallRelate(customerId: string, roundCustomerId: string) {
    const loading = ElLoading.service()
    if (callCenter.staffDefaultCallType === callType.sip) {
      const uuid = callCenter.jssipCallId
      roundCallRelateCustomer({
        relateShopOrderId: customerId,
        relateLinkId: customerId,
        id: roundCustomerId
      }).then(() => {
        sipQuickDialRelateCdr({
          gcId: uuid,
          bizType: 1,
          objectId: roundCustomerId,
          dataType: 1,
          dialScene: 1
        })
        loading.close()
      })
    } else {
      loading.close()
      roundCallRelateCustomer({
        relateShopOrderId: customerId,
        relateLinkId: customerId,
        id: roundCustomerId,
        toBeContacted: false
      }).then(() => {
        useDacoHooks.value.setRoundCallrecordUrl('save')
      })
    }
  }
  return {
    startRoundCallProcessPc,
    shutdown,
    showCountDown,
    reCall,
    setRoundCallRules,
    evokeMobileStartRoundCall,
    roundCallRelate
  }
}
